import { render, staticRenderFns } from "./AssessmentListingEditQuestion.vue?vue&type=template&id=3528b88c&scoped=true&"
import script from "./AssessmentListingEditQuestion.vue?vue&type=script&lang=js&"
export * from "./AssessmentListingEditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentListingEditQuestion.vue?vue&type=style&index=0&id=3528b88c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528b88c",
  null
  
)

export default component.exports